
import { shuffleArray } from "~/utils/utils";
export default {
  data() {
    return {
      videoId: 0
    };
  },

  async asyncData({ $axios, params, env }) {
    try {
      const path = params.video;
      const lastDashIndex = path.lastIndexOf("-");
      const videoId = Number(path.substring(lastDashIndex + 1, path.length));
      // 并行处理多个异步请求
      const [videoDetailResponse, relatedVideosResponse, allVideosResponse] = await Promise.all([
        $axios.$get("/api/video/detail", {
          params: {
            site_id: env.SITE_ID,
            video_id: videoId
          }
        }),

        $axios.$get("/api/video/get_related", {
          params: {
            site_id: env.SITE_ID,
            video_id: videoId,
            size: 3,
            page: 1
          }
        }),

        $axios.$get("/api/video/all_video", {
          params: {
            site_id: env.SITE_ID,
            exclude_series_video_id: videoId,
            size: 10,
            page: 1
          }
        })
      ]);

      // 返回多个接口的数据
      return {
        videoId,
        videoDetailResponse,
        allVideos: [...relatedVideosResponse.list, ...shuffleArray(allVideosResponse.list)]
      };
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
};
